import { createRouter, createWebHistory } from "vue-router";
import { getAuth } from "firebase/auth";

import LoginPage from "@/components/LoginPage.vue";
import QRCodePage from "@/components/QRCodePage.vue";
import MessageSender from "@/components/messages/MessageSender.vue";
import KanbanBoard from "@/components/kanban/QuadroKanban.vue";
import UserDashboard from "@/components/dashboard/UserDashboard.vue";
import GoogleSearch from "@/components/search/GoogleSearch.vue";
import MapsSearch from "@/components/search/MapsSearch.vue";
import CNPJSearch from "@/components/search/CNPJSearch.vue";
import { secureFetch } from "./main";
import { logout } from "./utils/sessionUtils";

const routes = [
  {
    path: "/",
    name: "Login",
    component: LoginPage,
    meta: {
      requiresAuth: false,
      requiresWhatsapp: false,
    },
  },
  {
    path: "/qr-code",
    name: "QRCode",
    component: QRCodePage,
    meta: {
      requiresAuth: true,
      requiresWhatsapp: false,
    },
  },
  {
    path: "/enviar-mensagens",
    name: "MessageSender",
    component: MessageSender,
    meta: {
      requiresAuth: true,
      requiresWhatsapp: true,
    },
  },
  {
    path: "/kanban",
    name: "KanbanBoard",
    component: KanbanBoard,
    meta: {
      requiresAuth: true,
      requiresWhatsapp: true,
    },
  },
  {
    path: "/dashboards",
    name: "UserDashboard",
    component: UserDashboard,
    meta: {
      requiresAuth: true,
      requiresWhatsapp: true,
    },
  },
  {
    path: "/pesquisa-google",
    name: "GoogleSearch",
    component: GoogleSearch,
    meta: {
      requiresAuth: true,
      requiresWhatsapp: false,
    },
  },
  {
    path: "/pesquisa-maps",
    name: "MapsSearch",
    component: MapsSearch,
    meta: {
      requiresAuth: true,
      requiresWhatsapp: false,
    },
  },
  {
    path: "/pesquisa-cnpj",
    name: "CNPJSearch",
    component: CNPJSearch,
    meta: {
      requiresAuth: true,
      requiresWhatsapp: false,
    },
  },
];

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;

const router = createRouter({
  history: createWebHistory(apiBaseUrl),
  routes,
});

//Instância do Auth (fluxo DEV/local) + token (para fluxo SSO/mag-auth)
const auth = getAuth();

async function checkWhatsappStatus() {
  const response = await secureFetch(`${apiBaseUrl}/whatsapp-status`);

  if (!response) {
    return {
      connected: false,
      status: "FAILED",
    }
  }

  return await response.json();
}

router.beforeEach(async (to, from, next) => {
  const firebaseUser = auth.currentUser;
  const token = localStorage.getItem("userToken");

  const isLoggedIn = !!firebaseUser || !!token;

  if (to.meta.requiresAuth && !isLoggedIn) {
    console.warn(
      "🔐 Nenhuma sessão válida (Firebase ou token). Redirecionando para login..."
    );
    return next("/");
  }

  if (to.meta.requiresWhatsapp) {
    try {
      console.log("IF DO WHATSAPP");
      const { connected, status } = await checkWhatsappStatus();
      console.log(connected);

      switch (status) {
        case "CONNECTED":
          return next();

        case "INITIALIZING":
          return next();

        case "FAILED":
          alert("Sessão do whatsapp expirada (conexão falhou). Faça o login novamente.");
          await logout();
          return next("/");

        default:
          alert("Escaneie o QR code novamente.");
          return next({
            path: "/qr-code"
          });
      }
    } catch (error) {
      console.error(`Erro ao verificar whatsapp: ${error}`);
      return next("/");
    }
  }

  // ✅ Se já está logado e está indo para "/" OU caiu em "/pesquisa-cnpj" logo após o SSO
  if (isLoggedIn && (to.path === "/" || to.path === "/pesquisa-cnpj")) {
    const acessoComWhatsapp =
      localStorage.getItem("acessoComWhatsapp") === "true";
    const qrCodeScanned =
      localStorage.getItem("qrCodeScanned") === "true";
    const lastPage = localStorage.getItem("currentPage") || "/pesquisa-cnpj";

    // 🔹 Se NÃO marcou "Acesso com WhatsApp" → vai pra última página usada
    if (!acessoComWhatsapp) {
      if (to.path !== lastPage) {
        return next(lastPage);
      }
      return next();
    }

    // 🔹 Marcou "Acesso com WhatsApp" mas AINDA NÃO escaneou o QR → força ir pro QR-Code
    if (acessoComWhatsapp && !qrCodeScanned && to.path !== "/qr-code") {
      return next("/qr-code");
    }

    // 🔹 Marcou "Acesso com WhatsApp" e JÁ escaneou o QR:
    //     se estiver caindo em "/" (ex.: reload depois de logado), manda pra última página
    if (acessoComWhatsapp && qrCodeScanned && to.path === "/" && to.path !== lastPage) {
      return next(lastPage);
    }

    // Caso normal: deixa seguir
    return next();
  }


  return next();
});

export default router;
